<template>
  <div class="__mainbacground">
    <div class="guest container-fluid d-flex py-5 justify-content-center">
      <div class="guest__container">
        <div class="mb-4 text-center">
          <h3>Welcome to Andalin</h3>
          <p>Let's Active Your Account Here</p>
        </div>
        <b-form @submit.prevent="handleSubmit" novalidate>
          <b-form-group class="mb-3">
            <b-form-input type="text" name="name"
              :state="errors.first('name') && false"
              v-validate="'required'"
              placeholder="Enter your name"
              v-model="form.name"
            ></b-form-input>
            <p v-if="errors.has('name')" class="fontstyle__errormsg">
              {{ errors.first('name') }}
            </p>
          </b-form-group>
          <b-form-group class="mb-3">
            <b-form-input type="text" name="company name"
              :state="errors.first('company name') && false"
              v-validate="'required'"
              placeholder="Company Name"
              v-model="form.compname"
            ></b-form-input>
            <p v-if="errors.has('company name')" class="fontstyle__errormsg">
              {{ errors.first('company name') }}
            </p>
          </b-form-group>
          <b-form-group class="mb-3">
            <b-form-input type="number" name="phone"
              :state="errors.first('phone') && false"
              v-validate="'required'"
              placeholder="Phone Number"
              v-model="form.phone"
            ></b-form-input>
            <p v-if="errors.has('phone')" class="fontstyle__errormsg">
              {{ errors.first('phone') }}
            </p>
          </b-form-group>
          <div class="text-center">
            <button class="button__bluecorporite mt-3" type="submit">Next</button>
          </div>
           <p class="textfooter text-center pb-3">By registering you confirm that you accept the <br>
            <a @click.prevent="terms()" href="#">Terms &amp; Conditions</a> and
            <a @click.prevent="policy()" href="#">Privacy Policy</a>
          </p>
        </b-form>
    </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'GuestPersonalData',
  data: () => ({
    form: {
      name: '',
      phone: '',
      compname: ''
    }
  }),
  computed: {
    ...mapGetters({
      guestPersonal: 'auth/guestPersonal',
      errorGuestPersonal: 'auth/errorGuestPersonal',
      isLoadingGuestPersonal: 'auth/isLoadingGuestPersonal',

      profile: 'auth/profile'
    })
  },
  methods: {
    handleSubmit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store.dispatch('auth/PUT_GUEST_DATA', this.form)
        }
      })
    },
    terms () {
      this.$eventHub.$emit('dialog-rule-terms')
    },
    policy () {
      this.$eventHub.$emit('dialog-rule-policy')
    }
  },
  watch: {
    guestPersonal (data) {
      if (data && data.length > 0) {
        this.$router.push({
          name: 'ManagementShipmentDetail',
          params: {
            id_shipment: this.profile.shipmentId,
            order_number: this.profile.orderNumber.split('/').join('-')
          }
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/guestPersonalData/index.vue